import { use } from 'react';

import { TenantSelectionContext } from 'contexts/TenantSelectionContext';

export default function useTenantSelection() {
  const context = use(TenantSelectionContext);

  if (!context) {
    throw new Error('useTenantSelection must be used inside TenantSelectionProvider');
  }

  return context;
}
